module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/2/2-1c53f30304640e2fb728bd8a8581a64a.jpg";